import PropTypes from 'prop-types'
import styled from 'styled-components'

const Styled = styled.div`

  .highlight {
    color: #C21110;
  }

  .pizza-card {
    background-image: url(${props => props.bgimage});
    background-size: cover;
    height: 393px;
    padding-top: 25px;
    padding-bottom: 25px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    .sc-img {
      min-height: 153px;
      .sc {
        width: 250px;
      }
    }

    @media (max-width: 768px) {
      .sc-img {
        .sc {
          width: auto;
        }
      }
    }
  }

  .pizza-card-middle {
    padding-top: 10px;
    padding-bottom: 10px;
    // background-image: url(${props => props.midbgimage});
    background-color: #fff;
    background-size: cover;
    text-align: center;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  .pizza-card-footer {
    margin-top: 20px;
    .ant-col {
      .ant-btn-danger {
        border-top-left-radius: 0px !important;
        border-top-right-radius: 0px !important;
      }
    }
  }

  .img-absolute {
    position: absolute;
  }
`

export const StyledSuperCard = ({ bgimage, midbgimage, children }) => {
  return (<Styled bgimage={bgimage} midbgimage={midbgimage}>{children}</Styled>)
}

StyledSuperCard.propTypes = {
  children: PropTypes.any,
  bgimage: PropTypes.any,
  midbgimage: PropTypes.any
}
